import { Col, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import "./styles/RequestIPTVModal.css";

const UpdateUserInputUniqueIdModal: React.FC<
  UpdateUserInputUniqueIdModalProp
> = ({ show, handleClose, userInputUniqueId, intPkConnectionID }) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateUserInputUniqueIdApiProp>(
    "connections/updateUserInputUniqueId",
    true
  );

  const onFinish = (values: any) => {
    const { userInputUniqueId } = values;
    const dataToSend: UpdateUserInputUniqueIdApiProp = {
      intPkConnectionID,
      userInputUniqueId: userInputUniqueId.trim(),
    };
    postApiData(dataToSend);
  };

  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);

  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  useEffect(() => {
    if (show) {
      form.setFieldsValue({
        userInputUniqueId: userInputUniqueId || "",
      });
    }
  }, [show, userInputUniqueId, form]);

  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title="Update Unique ID"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              name="updateUserInputUniqueIdForm"
              initialValues={{
                userInputUniqueId: userInputUniqueId || "",
              }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">
                    Put Your Own Unique ID
                  </span>
                }
                name="userInputUniqueId"
                rules={[
                  {
                    required: true,
                    message: "Please enter a unique ID",
                  },
                  {
                    min: 1,
                    message: "Unique ID cannot be empty",
                  },
                  {
                    max: 40,
                    message: "Unique ID cannot exceed 40 characters",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Enter your unique ID (max 40 characters)"
                  maxLength={40}
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateUserInputUniqueIdModal;

